/**
 * Resolve the single resource id for a maintenance event regardless of
 * payload shape. Maintenance always has exactly one resource.
 *
 * Handles all known shapes returned by the calendar listing and detail APIs:
 *   - top-level flat:   event.resourceID / event.resourceId
 *   - nested er flat:   er.resourceID / er.resourceId
 *   - nested er object: er.resource.id
 *
 * @param {Object|null} event
 * @returns {string|number|null}
 */
export function getMaintenanceResourceId(event) {
	if (!event) return null;
	if (event.resourceID != null) return event.resourceID;
	if (event.resourceId != null) return event.resourceId;
	const er = (event.eventResources && event.eventResources[0]) || null;
	if (!er) return null;
	return er.resourceID ?? er.resourceId ?? er.resource?.id ?? null;
}
